import React from 'react';
import { Card } from './ui/card';
import { Play, TrendingUp, Tv } from 'lucide-react';

const SeriesSection = () => {
  const handleCardClick = () => {
    // Scroll to hero CTA button
    document.getElementById('inicio')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const series = [
    {
      id: 1,
      title: "Drama Familiar",
      seasons: 5,
      episodes: 60,
      trending: true,
      image: "https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg"
    },
    {
      id: 2,
      title: "Suspense Criminal",
      seasons: 3,
      episodes: 36,
      trending: true,
      image: "https://images.pexels.com/photos/1190297/pexels-photo-1190297.jpeg"
    },
    {
      id: 3,
      title: "Comédia Sitcom",
      seasons: 8,
      episodes: 120,
      trending: false,
      image: "https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg"
    },
    {
      id: 4,
      title: "Ficção Fantástica",
      seasons: 4,
      episodes: 48,
      trending: true,
      image: "https://images.pexels.com/photos/1190297/pexels-photo-1190297.jpeg"
    },
    {
      id: 5,
      title: "Ação e Aventura",
      seasons: 6,
      episodes: 72,
      trending: false,
      image: "https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg"
    },
    {
      id: 6,
      title: "Mistério Sobrenatural",
      seasons: 2,
      episodes: 24,
      trending: true,
      image: "https://images.pexels.com/photos/1190297/pexels-photo-1190297.jpeg"
    }
  ];

  return (
    <section id="series" className="py-16 md:py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            Maratone Suas <span className="text-red-600">Séries</span>
          </h2>
          <p className="text-gray-400 text-lg md:text-xl">
            Assista temporadas completas quando quiser
          </p>
        </div>

        {/* Series Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {series.map((show) => (
            <Card
              key={show.id}
              onClick={handleCardClick}
              className="group relative overflow-hidden bg-zinc-900 border-zinc-800 hover:border-red-600 transition-all duration-300 cursor-pointer hover:scale-105"
            >
              {/* Thumbnail */}
              <div className="relative h-64 md:h-80 overflow-hidden">
                <img
                  src={show.image}
                  alt={show.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-colors"></div>

                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="bg-red-600 w-16 h-16 rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform">
                    <Play className="w-8 h-8 text-white fill-white" />
                  </div>
                </div>

                {/* Trending Badge */}
                {show.trending && (
                  <div className="absolute top-4 left-4 bg-red-600 text-white px-3 py-1 rounded-full text-sm font-bold flex items-center gap-1">
                    <TrendingUp className="w-4 h-4" />
                    Em Alta
                  </div>
                )}

                {/* Episodes Info */}
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="bg-black/80 backdrop-blur-sm text-white px-3 py-2 rounded text-sm flex items-center justify-between">
                    <div className="flex items-center gap-1">
                      <Tv className="w-4 h-4" />
                      <span>{show.seasons} Temporadas</span>
                    </div>
                    <span>{show.episodes} Eps</span>
                  </div>
                </div>
              </div>

              {/* Series Info */}
              <div className="p-4 md:p-6">
                <h3 className="text-xl font-bold text-white group-hover:text-red-500 transition-colors">
                  {show.title}
                </h3>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SeriesSection;
